<template>
  <div v-if="!isLoading && report" class="container mt-4 h-100 w-100">
    <TopNav :showOpenMainNav="true" :icon="['far', 'users']" />
    <h2 class="mt-4">
      {{ report.title }}
    </h2>
    <div class="my-5 h-100 w-100">
      <ReportComponent :report="report" />
    </div>
  </div>
</template>

<script>
import TopNav from '@/web/components/navigation/TopNav.vue';
import ReportComponent from '@/web/components/reports/ReportComponent.vue';
import { errorToMessage } from '@/core/utils/errors';

export default {
  name: 'ReportDetail',
  components: {
    TopNav,
    ReportComponent,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  async mounted() {
    try {
      this.report = await this.$store.dispatch('report/getMetabaseReport', {
        reportId: this.$route.params.report_id,
      });
      this.isLoading = false;
    } catch (error) {
      this.$notify({
        group: 'app',
        type: 'error',
        title: 'Failed to load report',
        text: errorToMessage(error.response, `Request failed: ${error}`),
        duration: -1, // stay ON
      });
    }
  },
};
</script>
<style lang="scss" scoped></style>
